/* eslint-disable no-underscore-dangle */
import dialCodes from './dialCodes.json';

const PHONE_NUMBER_REGEX = /(?<group1>\d{3})(?<group2>\d{3})(?<group3>\d*)/g;
const PHONE_NUMBER_FORMAT = '$<group1> $<group2> $<group3>';
const SPACES = /\s/g;

export default function formatPhoneNumber(phone: string) {
  const phone_ = phone?.trim() || '';

  const item = dialCodes.find(({ dialCode }) => phone_.startsWith(dialCode));

  if (item) {
    return `${item.dialCode} ${phone_
      .slice(item.dialCode.length)
      .replace(PHONE_NUMBER_REGEX, PHONE_NUMBER_FORMAT)}`;
  }

  return `${phone_.replace(PHONE_NUMBER_REGEX, PHONE_NUMBER_FORMAT)}`;
}

export type PhoneNumberInfo = (typeof dialCodes)[number] & {
  phoneNumber: string;
};

export function getPhoneNumberInfo(
  phone: string,
  defaultCountryCode: string
): PhoneNumberInfo {
  const phone_ = phone?.trim() || '';

  const item = dialCodes.find(({ dialCode }) => phone_.startsWith(dialCode));

  if (item) {
    const phoneNumber = `${phone_
      .slice(item.dialCode.length)
      .replace(SPACES, '')
      .slice(0, 12)
      .replace(PHONE_NUMBER_REGEX, PHONE_NUMBER_FORMAT)
      .trim()}`;

    return {
      ...item,
      phoneNumber,
    };
  }

  const defaultItem = dialCodes.find(({ code }) => defaultCountryCode === code);

  const phoneNumber = `${phone_
    .replace(SPACES, '')
    .slice(0, 12)
    .replace(PHONE_NUMBER_REGEX, PHONE_NUMBER_FORMAT)
    .trim()}`;

  return {
    code: '',
    dialCode: '',
    flag: '',
    name: '',
    ...defaultItem,
    phoneNumber,
  };
}

export function removePhoneNumberPrefix(phoneNumber?: string): string {
  return phoneNumber?.replace(/\+/g, '') || '';
}
